export const getSkus = ({ designId, data }) => {
    return data.map(x => {
        let sku = {};
        sku['design'] = designId;
        sku['type'] = x.resource_type;
        if (x.resource_type === 'design_resource') {
            sku['design_resource'] = x.id;
        } else if (x.resource_type === '123rf_image') {
            sku['rf_image'] = x.id;
        } else if (x.resource_type === '123rf_plus_image') {
            sku['rf_plus_image'] = x.id;
        } else if (x.resource_type === 'pixlr_image') {
            sku['pixlr_image'] = x.id;
        }
        return sku;
    })
};